export enum ScreenNameEnum {
  SHARE = 'share',
  HOME = 'home',
  SHOT = 'shot',
  RESERVATION = 'reservation',
  SPACE_USAGE = 'spaceUsage',
  PROFILE = 'profile'
}
